module.exports = __webpack_public_path__ + "static/media/screen7.651a3824.png";